import { FETCH_PARCEL_SUCCESS, FETCH_PARCEL_ERROR } from 'constants/actionTypes'

const DEFAULT_STATE = {
  error: null,
  list: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PARCEL_SUCCESS:
      return {
        ...state,
        error: null,
        list: action.payload,
      }
    case FETCH_PARCEL_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return { ...state }
  }
}
